var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import TextInput from '../../Molecules/TextInput';
import { IconLookup } from '../../Atoms/Icon';
const SearchInput = (_a) => {
    var { className, inputClassName, iconClassName, delayToSearch = 0, onSearch = () => { }, placeholder = 'Search' } = _a, rest = __rest(_a, ["className", "inputClassName", "iconClassName", "delayToSearch", "onSearch", "placeholder"]);
    const handleSearch = useCallback((event) => {
        onSearch(event.target.value);
    }, [onSearch]);
    return (React.createElement(TextInput, Object.assign({ className: className, inputClassName: inputClassName, iconClassName: iconClassName, icon: IconLookup.MAGNIFIER, onChange: handleSearch, placeholder: placeholder, delay: delayToSearch }, rest)));
};
export default SearchInput;
